import { isEqualsIgnoringCase } from 'utils/stringUtils';

export const ROLE_FUNCTIONALITY_OPERATION_SEP = ':';

export const ROLE_FUNCTIONALITY_ADMIN = 'ADMIN';

export const ROLE_OPERATION_SAVE = 'SAVE';
export const ROLE_OPERATION_READ = 'READ';
export const ROLE_OPERATION_DELETE = 'DELETE';

/**
 * Checks if a user has role
 * @param user the user
 * @param role the role
 * @returns {boolean} true is user is authorized
 */
export function isAuthorized(user, role) {
  if (!user?.roles?.length > 0) {
    return false;
  }
  return user.roles.some((userRole) => isEqualsIgnoringCase(userRole, role));
}
